<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import { jwtDecode } from 'jwt-decode';
  
  const dispatch = createEventDispatcher();
  let isLoading = true;

  function isTokenExpired(token) {
    try {
      const decodedToken = jwtDecode(token);
      return Date.now() >= decodedToken.exp * 1000;
    } catch (error) {
      console.error('Error decoding token:', error);
      return true;
    }
  }

  async function validateToken() {
    const accessToken = localStorage.getItem('accessToken');
    
    if (accessToken && !isTokenExpired(accessToken)) {
      dispatch('pleaseProceed');
    } else {
      await handleExpiredOrMissingAccessToken();
    }
  }

  async function handleExpiredOrMissingAccessToken() {
    const refreshToken = localStorage.getItem('refreshToken');
    
    if (!refreshToken || isTokenExpired(refreshToken)) {
      dispatch('pleaseLogin');
      return;
    }

    await getAccessFromRefresh(refreshToken);
  }

  async function getAccessFromRefresh(refreshToken) {
    try {
      const response = await fetch('https://groupfruits.online/authentication/api/access_from_refresh/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ refresh_token: refreshToken }),
      });
      
      if (!response.ok) {
        throw new Error('Failed to refresh access token');
      }
      
      const data = await response.json();
      
      // Save the new access token
      localStorage.setItem('accessToken', data.access_token);
      
      // Save the new refresh token and remove the old one
      localStorage.setItem('refreshToken', data.refresh_token);
      
      dispatch('pleaseProceed');
    } catch (error) {
      console.error('Error getting access from refresh:', error);
      dispatch('pleaseLogin');
    }
  }

  onMount(async () => {
    await validateToken();
    isLoading = false;
  });
</script>

{#if isLoading}
  <div class="loader">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
{/if}

<style>
  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }

  .dot {
    width: 10px;
    height: 10px;
    background-color: #333;
    border-radius: 50%;
    margin: 0 5px;
    animation: bounce 1.4s infinite ease-in-out both;
  }

  .dot:nth-child(1) {
    animation-delay: -0.32s;
  }

  .dot:nth-child(2) {
    animation-delay: -0.16s;
  }

  @keyframes bounce {
    0%, 80%, 100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
</style>